import { GetSampleCounterRequest, GetSampleCounterResponse, ChangeProjectionService } from '@analysis/domain';
import { type RoiRepository, type RoiChangesRepository } from '../../ports';

export class GetSampleStatsUseCase {
  constructor(private readonly rois: RoiRepository, private readonly changes: RoiChangesRepository) {}

  public async execute(request: GetSampleCounterRequest): Promise<GetSampleCounterResponse> {
    const baseCounters = await this.rois.getSampleCounters(request);

    const pendingChanges = await this.changes.getForSampleAndAnalyst(request.sampleId, request.analystId);

    if (pendingChanges.length === 0) return baseCounters;

    const existingChangeIds = pendingChanges.filter((c) => !c.isNew).map((c) => c.id);

    const baselineMap = existingChangeIds.length > 0 ? await this.rois.batchGetByIds(existingChangeIds) : new Map();

    return ChangeProjectionService.projectCounters(baseCounters, pendingChanges, baselineMap);
  }
}
